// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"124":"5b74453d","210":"d40650dc","590":"34af69c7","656":"fbaac0d0","725":"0a6e5dbc"}[chunkId] + ".js";
};